/**
 * Signing out, in one place.
 *
 * There are two keys, and they were not always removed together. The token
 * is the session; `wb_admin_tenant` is who the session belongs to, and
 * App.js's AdminScoped brands every admin screen from it. Clearing only the
 * token leaves the previous agency's slug behind, so the next person to
 * sign in on that browser gets somebody else's name, logo and phone number
 * over their own account until something happens to overwrite it.
 *
 * Reported by a brand-new trial account that opened its Getting Started
 * guide and found Windlebrook Estates at the top of it.
 */
export function signOutLocal() {
  try {
    window.localStorage.removeItem("wb_admin_token");
    window.localStorage.removeItem("wb_admin_tenant");
  } catch {
    // Private mode, or storage blocked. The token is unreachable either
    // way, and there is nothing here worth failing a sign-out over.
  }
}

/** The tenant this browser has a SESSION for, or null.
 *
 *  Deliberately not "whatever is in wb_admin_tenant": without a token
 *  there is no session, and a leftover slug is somebody else's agency.
 */
export function sessionTenant() {
  try {
    if (!window.localStorage.getItem("wb_admin_token")) return null;
    const raw = window.localStorage.getItem("wb_admin_tenant");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
